function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import Markdown from 'markdown-to-jsx';
import * as React from 'react';
import {
StyledHeadline,
StyledParagraph,
StyledSmallCapsHeadline,
StyledSmallHeadline,
StyledSubHeadline } from "./styles";







export const MarkdownParser = ({
  children,
  options,
  titleColor,
  paragraphColor,
  ...restProps }) =>
{
  const { overrides = {}, ...restOptions } = options !== null && options !== void 0 ? options : {};
  return /*#__PURE__*/(
    React.createElement(Markdown, _extends({},
    restProps, {
      options: {
        ...restOptions,
        overrides: {
          ...overrides,
          h1: {
            component: StyledHeadline,
            props: {
              titleColor,
              className: 'Headline' } },


          h2: {
            component: StyledSubHeadline,
            props: {
              titleColor,
              className: 'SubHeadline' } },


          h3: {
            component: StyledSmallHeadline,
            props: {
              titleColor,
              className: 'SmallHeadline' } },


          h4: {
            component: StyledSmallCapsHeadline,
            props: {
              titleColor,
              className: 'SmallCapsHeadline' } },


          p: {
            component: StyledParagraph,
            props: {
              paragraphColor,
              className: 'Paragraph' } } } } }),





    children));


};